export const UN_WARP_ACTIVITY_TOKEN = 'UN_WARP_ACTIVITY_TOKEN';
export const ACTIVITY_AUTH_IDENTITY_TOKEN = 'ACTIVITY_AUTH_IDENTITY_TOKEN';
